<script lang="ts">
import { linkOpenEvent } from '@/modules/linkPreview'
import { widgetOptions } from '@/modules/options'
import { t } from '@/modules/translations'
import { escape } from '@/utils/escapeHtml'
import { linkify } from '@/utils/linkify'

import { GDPR_PLACEHOLDER_URL } from '../constants'
import PrivacyNotice from './content/PrivacyNotice.svelte'

type Props = {
	text: string
	replaceText?: string
	clamp?: boolean
	shouldSendLinkOpenedEvent?: boolean
}

let {
	text,
	replaceText = '',
	clamp = widgetOptions.getOptions().urlCardsEnabled,
	shouldSendLinkOpenedEvent = false,
}: Props = $props()
const isGdprNoticeText = $derived(text.match(GDPR_PLACEHOLDER_URL))
</script>

<div use:linkOpenEvent={shouldSendLinkOpenedEvent}>
	{#if isGdprNoticeText}
		{@html escape(text.replace(GDPR_PLACEHOLDER_URL, ''))}
		<div class="flex items-left -mt-3 pb-1">
			<PrivacyNotice label={$t('topBar.gdprTitle')} />
		</div>
	{:else}
		{@html linkify(text, { replaceText, clamp })}
	{/if}
</div>
